import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { HamburgerMenu } from './components/HamburgerMenu';
import { HeroSection } from './components/HeroSection';
import { IntroSection } from './components/IntroSection';
import { FeaturedWines } from './components/FeaturedWines';
import { TerroirSection } from './components/TerroirSection';
import { PhilosophySection } from './components/PhilosophySection';
import { SustainabilityCallout } from './components/SustainabilityCallout';
import { PressQuote } from './components/PressQuote';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // Scroll Reveal Logic
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    const elements = document.querySelectorAll('.section-reveal');
    elements.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return <div className="min-h-screen bg-white w-full overflow-x-hidden" data-id="element-0">
      <Header isMenuOpen={isMenuOpen} onToggleMenu={() => setIsMenuOpen(!isMenuOpen)} data-id="element-1" />

      <HamburgerMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <IntroSection data-id="element-5" />
        <FeaturedWines data-id="element-6" />
        <TerroirSection data-id="element-7" />
        <PhilosophySection data-id="element-8" />
        <SustainabilityCallout data-id="element-9" />
        <PressQuote data-id="element-10" />
        <CTASection data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}